import React, { useEffect } from "react";
import PropTypes from "prop-types";
import classes from "./button.module.css";

import { Button as BootStrapButton } from "react-bootstrap";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import { ReactSVG } from "react-svg";
import $ from "jquery";

export const Button = ({
  primary,
  backgroundColor,
  size,
  label,
  customStyle,
  iconCustomStyle,
  icon,
  onClick,
  disabled,
  disabledIcon,
  children,
  isTertiary,
  iconClass,
  className,
  ...props
}) => {
  let styleObject = Object.assign(
    {},
    backgroundColor && { backgroundColor: backgroundColor },
    icon !== undefined &&
      (label == "" || label == undefined) &&
      children == undefined && {
        padding: size === "Large" ? "16px" : size === "Medium" ? "12px" : "8px",
        width: size === "Large" ? "56px" : size === "Medium" ? "48px" : "40px",
        height: size === "Large" ? "56px" : size === "Medium" ? "48px" : "40px",
        boxShadow: "unset",
      },
    customStyle
  );
  let imageStyleObject = Object.assign(
    (label == "" || label == undefined) && {
      marginRight: 0,
    },
    iconCustomStyle
  );

  useEffect(() => {
    if (
      icon !== undefined &&
      (label == "" || label == undefined) &&
      children == undefined
    ) {
      if (disabled == true) {
        styleObject = Object.assign({}, styleObject, {
          backgroundColor: Colors.white,
          border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
        });
      }
      $(`.${classes.storybookButtonSecondary}`).hover(
        function () {
          $(this).css("border", `1px solid ${Colors.neutralShadesOfGainsboro}`);
        },
        function () {
          $(this).css("border", `1px solid ${Colors.neutralShadesOfGainsboro}`);
        }
      );
    }
  }, [disabled]);

  return (
    <>
      <style jsx>{`
        .${classes.storybookButtonPrimary} {
          color: ${Colors.white};
          background-color: ${Colors.mainShadeOfRed};
        }
        .${classes.storybookButtonPrimary}:hover {
          background-color: #ec2237;
        }
        .${classes.storybookButtonPrimary}:active {
          background-color: ${Colors.errorColor};
        }
        .${classes.storybookButtonPrimary}:focus {
          background-color: ${Colors.mainShadeOfRed};
          box-shadow: 0 0 0 0.25rem rgba(249, 55, 73, 0.3);
        }
        .${classes.storybookButtonPrimary}:active:focus {
          background-color: ${Colors.errorColor};
          box-shadow: unset;
        }
        .${classes.storybookButtonPrimary}:disabled {
          background-color: ${Colors.neutralShadesOfWhisper};
          color: ${Colors.neutralShadesOfDimGray};
        }

        .${classes.storybookButtonSecondary} {
          color: ${Colors.neutralShadesOfNero};
          background-color: transparent;
          border: 1px solid ${Colors.neutralShadesOfGainsboro};
        }
        .${classes.storybookButtonSecondary}:hover {
          background-color: ${Colors.neutralShadesOfWhisper};
          border: 1px solid ${Colors.neutralShadesOfNero};
          color: ${Colors.neutralShadesOfNero};
        }

        .${classes.storybookButtonSecondary}:active {
          background-color: ${Colors.neutralShadesOfGainsboro};
          border: 1px solid ${Colors.neutralShadesOfNero};
          color: ${Colors.neutralShadesOfNero};
        }
        .${classes.storybookButtonSecondary}:focus {
          background-color: ${Colors.white};
          border: 1px solid ${Colors.neutralShadesOfNero};
          color: ${Colors.neutralShadesOfNero};
          box-shadow: 0 0 0 0.25rem rgba(34, 34, 34, 0.3);
        }
        .${classes.storybookButtonSecondary}:active:focus {
          border: 1px solid ${Colors.neutralShadesOfNero};
          color: ${Colors.neutralShadesOfNero};
          background-color: ${Colors.neutralShadesOfGainsboro};
          box-shadow: unset;
        }
        .${classes.storybookButtonSecondary}:disabled {
          color: ${Colors.neutralShadesOfPinkSwan};
          border: 1px solid ${Colors.neutralShadesOfWhisper};
          background-color: ${Colors.white};
        }
        .${classes.tertiaryBtn} {
          background-color: ${Colors.white};
          color: ${Colors.neutralShadesOfNero};
          font-size: ${Fonts.b2.fontSize};
          font-family: ${Fonts.b2.fontFamily};
          line-height: 20px;
        }
        .${classes.tertiaryBtn}:hover {
          background-color: ${Colors.neutralShadesOfWhiteSmoke};
          color: ${Colors.neutralShadesOfNero};
        }
        .${classes.tertiaryBtn}:active:focus {
          background-color: ${Colors.neutralShadesOfWhisper};
          color: ${Colors.neutralShadesOfNero};
          box-shadow: unset;
        }
        .${classes.tertiaryBtn}:disabled {
          color: ${Colors.neutralShadesOfGainsboro};
          background-color: ${Colors.white};
        }
      `}</style>

      <button
        className={`${[
          classes.storybookButton,
          classes[`storybookButton${size}`],

          isTertiary === true
            ? classes.tertiaryBtn
            : primary
            ? classes.storybookButtonPrimary
            : classes.storybookButtonSecondary,
          className,
        ].join(" ")}`}
        style={{
          ...styleObject,

          fontSize:
            isTertiary === false
              ? size === "Large"
                ? Fonts.b1.fontSize
                : Fonts.b2.fontSize
              : Fonts.b2.fontSize,
          fontFamily:
            isTertiary === false
              ? size === "Large"
                ? Fonts.b1.fontFamily
                : Fonts.b2.fontFamily
              : Fonts.b2.fontFamily,
          lineHeight:
            isTertiary === false
              ? size === "Large"
                ? Fonts.b1.lineHeight
                : "20px"
              : "20px",
          ...customStyle,
        }}
        onClick={onClick}
        disabled={disabled ? disabled : false}
        {...props}
      >
        {icon && (
          <span
            className={` ${[classes.image, iconClass && iconClass].join(" ")}`}
            style={{ ...imageStyleObject }}
          >
            <ReactSVG src={disabled == true ? disabledIcon : icon} />
          </span>
        )}
        {label && label}
        {children && children}
      </button>
    </>
  );
};

Button.propTypes = {
  primary: PropTypes.bool,
  disabled: PropTypes.bool,
  backgroundColor: PropTypes.string,
  size: PropTypes.oneOf(["Small", "Medium", "Large"]),
  label: PropTypes.string.isRequired,
  customStyle: PropTypes.string,
  iconCustomStyle: PropTypes.string,
  iconClass: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  isTertiary: PropTypes.bool,
};

Button.defaultProps = {
  backgroundColor: null,
  primary: false,
  size: "Medium",
  onClick: undefined,
  customStyle: {},
  iconCustomStyle: {},
  isTertiary: false,
};
